import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { color } from '@coursera/coursera-ui';
import { SvgExternalLink } from '@coursera/coursera-ui/svg';

import { shouldShowTOSDisclaimer } from 'bundles/authentication/utils';
import countryCodeUtil from 'bundles/phoenix/utils/countryCodeUtil';

import _t from 'i18n!nls/user-account';

import 'css!./__styles__/AuthFormFooter';

type Props = {
  enableSSOLogin?: boolean;
  authMode: 'signup' | 'login';
};

class AuthFormFooter extends React.Component<Props> {
  static contextTypes = {
    getStore: PropTypes.func.isRequired,
  };

  renderTosLink() {
    return (
      <a href="/about/terms" target="ctos">
        {_t('Terms of Use')}
        <SvgExternalLink size={14} color={color.primaryText} style={{ marginBottom: '-4px', marginLeft: '4px' }} />
      </a>
    );
  }

  renderPrivacyLink() {
    return (
      <a href="/about/privacy" target="cprivacy">
        {_t('Privacy Policy')}
        <SvgExternalLink size={14} color={color.primaryText} style={{ marginBottom: '-4px', marginLeft: '4px' }} />
      </a>
    );
  }

  renderContents() {
    const { authMode, enableSSOLogin } = this.props;
    const { getStore } = this.context;

    if (authMode === 'login') {
      return null;
    } else if (authMode === 'signup' && !enableSSOLogin && shouldShowTOSDisclaimer()) {
      const countryCode = getStore && getStore('ApplicationStore')?.requestCountryCode;

      if (countryCodeUtil.isEEA(countryCode)) {
        return (
          <div>
            <FormattedHTMLMessage
              message={_t(
                `By signing up to create an account I accept Coursera's
                {tosLink} and {privacyLink}, including the
                <a href="{safeHarborHref}">processing of your personal data in the United States</a>.`
              )}
              tosLink={this.renderTosLink()}
              privacyLink={this.renderPrivacyLink()}
              safeHarborHref="/about/privacy/safeHarbor"
            />
            <input type="hidden" name="termsAgree" defaultValue="true" />
          </div>
        );
      } else {
        return (
          <div className={classNames('AuthFormFooter ', { 'p-t-1': enableSSOLogin })}>
            <FormattedHTMLMessage
              message={_t("By signing up to create an account I accept Coursera's {tosLink} and {privacyLink}.")}
              tosLink={this.renderTosLink()}
              privacyLink={this.renderPrivacyLink()}
            />
            <input type="hidden" name="termsAgree" defaultValue="true" />
          </div>
        );
      }
    }
  }

  render() {
    return <div className="rc-AuthFormFooter text-xs-center m-t-1s">{this.renderContents()}</div>;
  }
}

export default AuthFormFooter;
